export default __webpack_public_path__ + "static/media/doctor_dashboard_my_consultation.514f334f.svg";